<aside class="main-sidebar sidebar-dark-primary elevation-4_disables">
    <!-- Brand Logo -->
    <a routerLink="/customerDashboard" class="brand-link p-0">
      <img src="../../../../../app/assets/header_full_96.jpg" alt="AdminLTE Logo" class="img_top">

      <span style="display: none;">
        <img src="../../../../../app/assets/logo-min.png" alt="AdminLTE Logo" class="img_top">
        <label>PTC</label>
      </span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar mt-4">
      <!-- Sidebar user panel (optional) -->
      <!-- <div class="user-panel mt-3 pb-3 mb-3 d-flex">
        <div class="image">
          <img src="dist/img/user2-160x160.jpg" class="img-circle elevation-2" alt="User Image" >
          
        </div>
        <div class="info">
          <a href="#" class="d-block">Navved Durrani</a>
        </div>
      </div> -->

      <!-- SidebarSearch Form -->
      <!-- <div class="form-inline">
        <div class="input-group" data-widget="sidebar-search">
          <input class="form-control form-control-sidebar" type="search" placeholder="Search" aria-label="Search">
          <div class="input-group-append">
            <button class="btn btn-sidebar">
              <i class="fas fa-search fa-fw"></i>
            </button>
          </div>
        </div>
      </div> -->

      <!-- Sidebar Menu -->
      <nav class="mt-4" style="overflow-y: auto; overflow-x: hidden; height:calc(100vh - 190px);">
        <ul class="nav nav-pills nav-sidebar flex-column nav-treeview" data-widget="treeview"  role="menu" data-accordion="false">
          <li class="nav-item menu-open">
            <!-- <a  class="nav-link">
              <i class="nav-icon fas fa-user"></i>
              <p>
                Customers
                <i class="right fas fa-angle-left"></i>
              </p>
            </a> -->
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <a routerLinkActive="true" routerLink="addCustomer" class="nav-link" >
                  <i class="fa fa-user-plus fa-2x mr-2"></i>
                  <p>Add Customer</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLinkActive="true" routerLink="customerDashboard"  class="nav-link">
                  <i class="fa fa-list-ul fa-2x mr-2"></i>
                  <p>Customer List</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLinkActive="true" routerLink="completedList" class="nav-link">
                  <i class="fa fa-check-square fa-2x mr-2"></i>
                  <p>Completed List</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLinkActive="true" routerLink="customerArchiveList" class="nav-link">
                  <i class="fa fa-archive fa-2x mr-2"></i>
                  <p>Archive List</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLinkActive="true" routerLink="crprogram" class="nav-link">
                  <i class="fa fa-plus-square fa-2x mr-2"></i>
                  <p>CR Program</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLinkActive="true" routerLink="salestax" class="nav-link d-flex">
                  <i class="fa fa-dollar fa-2x mr-2"></i>
                  <p>Sales Tax Configuration</p>
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item menu-open">
            
          </li>
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
